import { render, staticRenderFns } from "./headerElement.vue?vue&type=template&id=90382db2&"
import script from "./headerElement.vue?vue&type=script&lang=js&"
export * from "./headerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports